define([
	"dojo/_base/declare",
	"csi/prefs/PreferenceView"
], function(declare, PreferenceView) {

	return declare(PreferenceView, {
		customOptions: [
			{name: "filterSettings", value: {}},
			{name: "printHeader", value: false},
			{name: "printOrientation", formerName: "Orientation", value: ""},
			{name: "printPaper", formerName: "PaperSize", value: ""}
		]
	});
});